import { render, staticRenderFns } from "./CountryTable.vue?vue&type=template&id=506583e0&"
import script from "./CountryTable.vue?vue&type=script&lang=js&"
export * from "./CountryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports